<template>
	<span>
		<em class="lt_text">Payment Term</em>
		<span class="int_type_no_border mgr_5">
			<CodeSelect className="tbl_select" :codes="codes" @input="change" v-model="code" />
		</span>
		<input type="text" class="tbl_int" v-model.trim="name_string" autocomplete="off" style="width:300px;" @input="update" />
	</span>
</template>

<script>
import CodeSelect from '@/components/common/CodeSelect';
import { apiSelectCodeList } from '@/api/basicinfo/code';

export default {
	name: 'SelectMultiPaymentTerm',
	data() {
		return {
			code: '',
			codes: [],
			name_string: '',
		};
	},
	methods: {
		async selectData() {
			const { data } = await apiSelectCodeList({
				code_type: 'PT',
				active_yn: 'A',
			});
			this.codes = data.codeList;
		},
		change(value) {
			if (this.name_string) this.name_string += ',' + value;
			else this.name_string = value;
			this.code = '';
			this.update();
		},
		update() {
			this.$emit('input', this.paymentTerms);
		},
	},
	computed: {
		paymentTerms: function() {
			let string = this.name_string;
			if (string) {
				return string.trim().split(',');
			} else {
				return [];
			}
		},
	},
	components: {
		CodeSelect,
	},
	created() {
		this.selectData();
	},
};
</script>

<style scoped></style>
